import "../../assets/styels/genric-styles/table.scss";
import UserEnterpraiseTable from "../../modules/enterpraiseUsers/templete/EnterpraiseUserTable";


const EnterpraisUserTablePage = () => {

  return (
    <>
      <div className="genric_page">
            <UserEnterpraiseTable/>
      </div>
    </>
  );
};

export default EnterpraisUserTablePage;
